import { types as t } from 'mobx-state-tree';

const PronounceFile = t.model('PronounceFile', {
  fileType: t.string,
  path: t.string,
  url: t.string,
});

export const VocabModel = t.model('VocabModel', {
  pronounce: t.maybeNull<any>(t.string),
  example: t.maybeNull<any>(t.string),
  image: t.maybeNull<any>(t.string),
  value: t.maybeNull<any>(t.string),
  type: t.maybeNull<any>(t.string),
  meaning: t.maybeNull<any>(t.string),
  group: t.maybeNull<any>(t.string),
  pronounceFile: t.maybeNull(PronounceFile),
});
